/* eslint-disable no-invalid-this */
import { THIRD_PARTY_SYNC_INDEXED } from '../../definitions';
import getTeamPayrollConfig from '@webapp-next/lib/request/webapp/people/get-team-payroll-config';
import { isFree } from '@webapp-next/lib/company-subscription';
import userHasPermission from '@webapp-next/lib/user-has-permission';

export default async function getModuleSetupPayrolls() {
  // do not allow sync when in free or cannot edit employees, pay
  if (
    isFree() ||
    !userHasPermission('Can_Manage_Employees') ||
    !userHasPermission('Can_Manage_Employee_PayDetails')
  ) {
    return;
  }

  this.setup.loadingPayrollEnabled = true;

  try {
    const { data } = await getTeamPayrollConfig({
      payrollIds: [THIRD_PARTY_SYNC_INDEXED.Xero.Key],
      locationIds: this.getMyLocationIds(),
    });

    this.setup.payrollEnableByLocationId = data;
    this.setup.payrollEnabled = Object.keys(data).reduce(
      (reduced, locationId) => {
        Object.keys(data[locationId]).forEach(
          payroll => (reduced[payroll] = true)
        );
        return reduced;
      },
      {}
    );
    this.setup.loadingPayrollEnabled = false;
  } catch (e) {
    console.error(e);
  }
}
